import wasmUrl from "@automerge/automerge/automerge.wasm?url";
import { initializeWasm } from "@automerge/automerge/slim";
import { GlobalWorkerOptions } from "pdfjs-dist";
import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";
import "./styles/tokens.css";

async function bootstrap(): Promise<void> {
  GlobalWorkerOptions.workerSrc = pdfWorkerUrl;
  await initializeWasm(wasmUrl);
  // Register custom elements only once the wasm runtime is ready.
  await import("./app/af-app.ts");
  document.getElementById("splash")?.remove();
  document.body.append(document.createElement("af-app"));
}

void bootstrap();
